import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';

const TerminalEasterEgg = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [input, setInput] = useState('');
  const [history, setHistory] = useState([
    { type: 'system', text: 'The AI Kompany Terminal v1.0.0' },
    { type: 'system', text: 'Type "help" for available commands' }
  ]);

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.ctrlKey && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setIsOpen(true);
      }
      if (e.key === 'Escape' && isOpen) {
        setIsOpen(false);
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [isOpen]);

  const commands = {
    help: {
      output: [
        'Available commands:',
        '  help      - Show this help message',
        '  services  - List our AI services',
        '  about     - About The AI Kompany',
        '  contact   - Contact information',
        '  clear     - Clear terminal',
        '  exit      - Close terminal'
      ]
    },
    services: {
      output: [
        'Our AI Solutions:',
        '  → AI Consultation',
        '  → AI Automation',
        '  → Agentic Systems',
        '  → AI Chat & Voice Agents',
        '  → Lead & Sales AI Agents',
        '  → Web Development',
        '  → App Development',
        '  → Custom AI Software'
      ]
    },
    about: {
      output: [
        'The AI Kompany - Automate & Scale Your Business With AI',
        '',
        'We help startups and companies implement AI systems',
        'to reduce costs, automate operations, and scale faster.',
        '',
        'Email: enquiry@theaikompany.com',
        'Web: www.theaikompany.com'
      ]
    },
    contact: {
      output: [
        'Contact Information:',
        'Email: enquiry@theaikompany.com',
        'Whatsapp: +91 9619612063',
        'Instagram: @the.ai_kompany',
        '',
        'Ready to transform your business with AI?',
        'Book a consultation today!'
      ]
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const cmd = input.trim().toLowerCase();

    setHistory(prev => [...prev, { type: 'input', text: input }]);

    if (cmd === 'clear') {
      setHistory([]);
    } else if (cmd === 'exit') {
      setIsOpen(false);
      setHistory([
        { type: 'system', text: 'The AI Kompany Secret Terminal v1.0.0' },
        { type: 'system', text: 'Type "help" for available commands' }
      ]);
    } else if (commands[cmd]) {
      setHistory(prev => [
        ...prev,
        ...commands[cmd].output.map(line => ({ type: 'output', text: line }))
      ]);
    } else if (cmd) {
      setHistory(prev => [
        ...prev,
        { type: 'error', text: `Command not found: ${cmd}` },
        { type: 'error', text: 'Type "help" for available commands' }
      ]);
    }

    setInput('');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-[#0B0F14] border-2 border-[#3DF2E0] rounded-md w-full max-w-3xl h-[600px] flex flex-col shadow-[0_0_30px_rgba(61,242,224,0.3)]">
        {/* Terminal Header */}
        <div className="flex items-center justify-between p-4 border-b border-[#3DF2E0]">
          <div className="flex items-center space-x-3">
            <div className="flex space-x-1.5">
              <div className="w-3 h-3 rounded-full bg-red-500"></div>
              <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
              <div className="w-3 h-3 rounded-full bg-green-500"></div>
            </div>
            <span className="text-sm font-['JetBrains_Mono',monospace] text-[#3DF2E0]">
              terminal.ai_kompany
            </span>
          </div>
          <button
            onClick={() => setIsOpen(false)}
            className="text-[#9CA3AF] hover:text-[#3DF2E0] transition-colors duration-200"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Terminal Content */}
        <div className="flex-1 overflow-y-auto p-6 space-y-2 font-['JetBrains_Mono',monospace] text-sm">
          {history.map((item, index) => (
            <div key={index} className={`
              ${item.type === 'system' ? 'text-[#3DF2E0]' : ''}
              ${item.type === 'input' ? 'text-white' : ''}
              ${item.type === 'output' ? 'text-[#9CA3AF]' : ''}
              ${item.type === 'error' ? 'text-red-400' : ''}
            `}>
              {item.type === 'input' && <span className="text-[#3DF2E0]">$ </span>}
              {item.text}
            </div>
          ))}
        </div>

        {/* Terminal Input */}
        <form onSubmit={handleSubmit} className="p-4 border-t border-[#3DF2E0]">
          <div className="flex items-center space-x-2">
            <span className="text-[#3DF2E0] font-['JetBrains_Mono',monospace] text-sm">$</span>
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              className="flex-1 bg-transparent text-white font-['JetBrains_Mono',monospace] text-sm outline-none"
              placeholder="Type a command..."
              autoFocus
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default TerminalEasterEgg;
